import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AccessControlService } from './services/access-control/access-control.service';

// Enforces the admin-managed block list app-wide. Added as canActivateChild on
// the BaseLayoutComponent route so a single guard covers every child route
// without touching each one's own canActivate array. The real enforcement is
// server-side (authMiddleware rejects /me with 403 USER_BLOCKED) — this guard
// only provides a clean redirect once AccessControlService has observed that.
@Injectable({
  providedIn: 'root'
})
export class BlockedUserGuard implements CanActivate, CanActivateChild {

  constructor(private access: AccessControlService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.check(state);
  }

  async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.check(state);
  }

  private async check(state: RouterStateSnapshot): Promise<boolean> {
    await this.access.ready();

    // Avoid a redirect loop when the guard's own target page is being navigated to.
    if (state.url === '/unauthorized') {
      return true;
    }

    if (this.access.isBlocked()) {
      this.router.navigate(['/unauthorized']);
      return false;
    }

    return true;
  }
}
